// Library Imports
import { faPhone, faUtensils } from "@fortawesome/free-solid-svg-icons";
// Components
import { Button } from "../../button/Button";
// Functions, Helpers, and Utils
import openPhoneDialer from "../../../functions/openPhoneDialer";
import { Locale, getLocalization } from "../../../helpers/localization";

const ActionExplanation: React.FC<{ deviceLanguage: Locale }> = ({
  deviceLanguage,
}) => {
  return (
    <div className="action-explanation display-flex flex-direction-column align-items-bottom  gap-20">
      <div className="call-to-action-buttons button-wrapper">
        <Button
          variant="neutral"
          buttonSize="medium"
          additionalClassNames="call-to-action-button"
          text={getLocalization("shared", "placeOrder", deviceLanguage)}
          icon={faPhone}
          leftIcon={true}
          onClickHandler={openPhoneDialer}
        />
        <Button
          variant="primary"
          buttonSize="medium"
          additionalClassNames="call-to-action-button"
          text={getLocalization("shared", "viewMenu", deviceLanguage)}
          icon={faUtensils}
          leftIcon={true}
          url="/menu"
        />
      </div>
    </div>
  );
};

export default ActionExplanation;
